/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Styles */
import './CardEpisodeSkeleton.scss';

const NUMBER_OF_CARDS = 3;

function CardEpisodeSkeleton({ className, dark }) {
  return (
    <div className={`dtv-html5-c-card-episode-skeleton ${className}`}>
      {Array.from({ length: NUMBER_OF_CARDS }).fill().map((value, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key -- only presentational
          key={index}
          className="dtv-html5-c-card-episode-skeleton__card"
        >
          <Skeleton dark={dark} className="dtv-html5-c-card-episode-skeleton__container-image" />
          <div className="dtv-html5-c-card-episode-skeleton__metadata">
            <Skeleton dark={dark} className="dtv-html5-c-card-episode-skeleton__title" />
            <Skeleton dark={dark} className="dtv-html5-c-card-episode-skeleton__subtitle" />
            <Skeleton dark={dark} className="dtv-html5-c-card-episode-skeleton__description" />
          </div>
        </div>
      ))}
    </div>
  );
}

CardEpisodeSkeleton.propTypes = {
  className: PropTypes.string,
  dark: PropTypes.bool,
};

CardEpisodeSkeleton.defaultProps = {
  className: '',
  dark: false,
};

export default memo(CardEpisodeSkeleton);
